<div class="no_data_container">
  <img *ngIf="showImage" [src]="path" alt="No Data" />
  <p>
    {{ msg }}
  </p>
</div>
